import { Node, mergeAttributes } from '@tiptap/core'

export const TwoColumn = Node.create({
  name: 'twoColumn',

  group: 'block',

  content: 'block+',

  parseHTML () {
    return [
      { tag: 'div[data-type="two-column"]' }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': 'two-column', style: 'display:flex;flex-direction:column;gap:2px;' }),
      0
    ]
  }
})
